(function () {
  function traduciLabelColore() {
    document.querySelectorAll('legend.form__label').forEach(function (leg) {
      leg.childNodes.forEach(function (node) {
        if (
          node.nodeType === Node.TEXT_NODE &&
          node.textContent.trim() === 'Color:'
        ) {
          node.textContent = node.textContent.replace('Color:', 'Colore:');
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', traduciLabelColore);

  // Osserva solo il container dei prodotti o variant-selects, non tutto il body
  document.addEventListener('DOMContentLoaded', function() {
    var target = document.getElementById('ProductGridContainer') || document.querySelector('variant-selects');
    if (!target) {
      setTimeout(function() {
        var t = document.querySelector('variant-selects');
        if (t) {
          var obs = new MutationObserver(traduciLabelColore);
          obs.observe(t, { childList: true, subtree: true });
        }
      }, 1000);
      return;
    }
    var obs = new MutationObserver(traduciLabelColore);
    obs.observe(target, { childList: true, subtree: true });
  });
})();


// filtri colore
(function() {
  const colorMap = {
    'gray': 'grigio', 'space gray': 'grigio', 'grigio siderale': 'grigio',
    'graphite': 'grigio', 'marble gray': 'grigio', 'gray titanium': 'grigio',
    'natural titanium': 'grigio', 'moonstone gray': 'grigio',
    'mystic gray': 'grigio', 'phantom gray': 'grigio',
    'titanium gray': 'grigio', 'onyx gray': 'grigio', 'titanium': 'grigio',
    'blue': 'blu', 'midnight': 'blu', 'sky blue': 'blu', 'icy blue': 'blu',
    'awesome iceblue': 'blu', 'sapphire blue': 'blu', 'pacific blue': 'blu',
    'sierra blue': 'blu', 'ultramarine': 'blu', 'blue titanium': 'blu',
    'titanium icyblue': 'blu', 'blue shadow': 'blu', 'cloud blue': 'blu',
    'midnight green': 'blu', 'blue titanic': 'blu', 'blue black': 'blu', 'silver blue': 'blu',
    'blue navy': 'blu navy', 'navy': 'blu navy', 'awesome navy': 'blu navy', 'stalight': 'blu navy',
    'white': 'bianco', 'galassia': 'bianco', 'white titanium': 'bianco',
    'cloud white': 'bianco', 'awesome white': 'bianco', 'prism white': 'bianco',
    'phantom white': 'bianco', 'starlight': 'bianco',
    'silver shadow': 'silver', 'silver blue titanium': 'silver',
    'white silver titanium': 'silver', 'phantom silver': 'silver', 'titanium whitesilver': 'silver',
    'pink gold': 'gold',
    'black': 'nero', 'phantom black': 'nero', 'onyx black': 'nero',
    'crafted black': 'nero', 'black titanium': 'nero', 'awesome black': 'nero',
    'ebony black': 'nero', 'prism black': 'nero', 'titanium jetblack': 'nero',
    'jetblack': 'nero', 'cosmic black': 'nero', 'space black': 'nero',
    'mezzanotte': 'nero', 'titanium black': 'nero',
    'red': 'rosso', 'coral': 'rosso', 'coral red': 'rosso', 'product(red)': 'rosso',
    'product (red)': 'rosso', 'producct (red)': 'rosso', 'procuct (red)': 'rosso',
    'producct(red)': 'rosso', 'product red': 'rosso',
    'green': 'verde', 'jade green': 'verde', 'alpine green': 'verde', 'mint': 'verde',
    'green water': 'verde', 'verde acqua': 'verde', 'lime': 'verde',
    'jade green titanium': 'verde', 'titanium green': 'verde', 'stage': 'verde',
    'light green': 'verde', 'awesome lime': 'verde', 'phantom green': 'verde',
    'pink': 'rosa', 'pink gold titanium': 'rosa', 'phantom pink': 'rosa',
    'yellow': 'giallo', 'amber yellow': 'giallo', 'titanium yellow': 'giallo', 'onyx yellow': 'giallo',
    'purple': 'viola', 'lavender': 'viola', 'cobalt violet': 'viola', 'bora purple': 'viola',
    'titanium violet': 'viola', 'violet': 'viola', 'phantom violet': 'viola', 'deep purple': 'viola',
    'orange': 'arancione', 'sandstone orange': 'arancione',
    'titanium orange': 'arancione', 'cosmic orange': 'arancione',
    'desert titanium': 'marrone', 'khaki': 'marrone',
    'cream': 'beige',
    'teal': 'multicolore', 'azzurro': 'multicolore', 'peach': 'multicolore'
  };

  const invalidValues = new Set(['n/d', 'nd', '']);
  const isInvalidValue = (val) => {
    if (!val) return true;
    return invalidValues.has(val.toString().toLowerCase().trim());
  };

  function getBaseColor(color) {
    if (!color) return color;
    return colorMap[color.toLowerCase()] || color.toLowerCase();
  }

  // Cache dati prodotti per collection
  const productDataCache = {};

  async function fetchProductData(collectionHandle) {
    if (productDataCache[collectionHandle]) {
      return productDataCache[collectionHandle];
    }
    try {
      const res = await fetch(`/collections/${collectionHandle}/products.json?limit=250`);
      const data = await res.json();
      const products = data.products || [];
      const map = {};
      products.forEach(p => {
        const colors = new Set();
        const memory = new Set();
        p.variants.forEach(v => {
          if (!v.available) return;
          p.options.forEach((opt, idx) => {
            const optName = opt.name.toLowerCase();
            const value = v[`option${idx + 1}`];
            if (!value || isInvalidValue(value)) return;
            if (optName === 'memoria' || optName === 'storage') {
              memory.add(value.toLowerCase());
            } else if (optName === 'color' || optName === 'colore') {
              colors.add(value.toLowerCase());
            }
          });
        });
        map[p.handle] = {
          available_colors: Array.from(colors),
          available_memory: Array.from(memory)
        };
      });
      productDataCache[collectionHandle] = map;
      return map;
    } catch(e) {
      console.error('Fetch product data error:', e);
      return {};
    }
  }

  // Legge il colore attivo dalla label della checkbox selezionata
  function getActiveColorFromDOM() {
    const checked = document.querySelector('input[type="checkbox"][name*="color-pattern"]:checked');
    if (!checked) return null;
    const li = checked.closest('li');
    if (!li) return null;
    const labelText = li.querySelector('.facet-checkbox__text, .visually-hidden')?.textContent?.trim();
    if (!labelText) return null;
    const clean = labelText.replace(/\s*\(\d+.*?\)\s*$/, '').trim().toLowerCase();
    return clean;
  }

  // Legge la memoria attiva dalla checkbox selezionata
  function getActiveMemoryFromDOM() {
    const checked = document.querySelector('input[type="checkbox"][name*="option.memoria"]:checked');
    if (!checked) return null;
    const li = checked.closest('li');
    if (!li) return null;
    const labelText = li.querySelector('.facet-checkbox__text, .visually-hidden')?.textContent?.trim();
    if (!labelText) {
      return checked.value?.toLowerCase() || null;
    }
    return labelText.replace(/\s*\(\d+.*?\)\s*$/, '').trim().toLowerCase();
  }

  function processGrid(productData) {
    const activeColor = getActiveColorFromDOM();
    const activeMemory = getActiveMemoryFromDOM();

    if ((!activeColor && !activeMemory) || !productData) {
      // Nessun filtro custom attivo: ripristina pulsante "Carica di più"
      const loadMore = document.querySelector('load-more, .load-more');
      if (loadMore) loadMore.style.display = '';
      return;
    }

    const cards = document.querySelectorAll('#product-grid li.grid__item');
    if (!cards.length) return;

    let visibleCount = 0;

    cards.forEach(card => {
      const link = card.querySelector('a[href*="/products/"]');
      const match = link?.href.match(/\/products\/([^?#/]+)/);
      if (!match) { visibleCount++; return; }
      const handle = match[1];
      const data = productData[handle];
      if (!data) { visibleCount++; return; }

      let colorOk = true;
      let memoryOk = true;

      if (activeColor) {
        colorOk = data.available_colors.some(color => {
          return getBaseColor(color) === activeColor;
        });
      }

      if (activeMemory) {
        memoryOk = data.available_memory.some(mem => mem === activeMemory);
      }

      if (!colorOk || !memoryOk) {
        card.style.display = 'none';
      } else {
        card.style.display = '';
        visibleCount++;
      }
    });

    const counters = document.querySelectorAll('#ProductCountDesktop, #ProductCount');
    counters.forEach(el => {
      el.textContent = el.textContent.replace(/\d+/, visibleCount);
    });

    // Nasconde "Carica di più" quando un filtro custom è attivo
    const loadMore = document.querySelector('load-more, .load-more');
    if (loadMore) loadMore.style.display = 'none';
  }

  async function init() {
    const collectionHandle = window.location.pathname.split('/collections/')[1]?.split('/')[0];
    if (!collectionHandle) return;

    const productData = await fetchProductData(collectionHandle);
    processGrid(productData);
  }

  // Esegui al load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Osserva aggiornamenti AJAX del container
  document.addEventListener('DOMContentLoaded', function() {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;
    let debounceTimer;
    const observer = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(init, 200);
    });
    observer.observe(container, { childList: true, subtree: true });
  });
})();


// Auto-seleziona la variante disponibile più economica sulla pagina prodotto
(function() {
  if (window.location.pathname.indexOf('/products/') === -1) return;
  if (!window.__productVariants) return;

  const invalidOptionValues = new Set(['n/d', 'nd', '']);
  function isInvalidOption(val) {
    if (!val) return true;
    return invalidOptionValues.has(val.toString().toLowerCase().trim());
  }

  function selectCheapestAvailable() {
    const variants = window.__productVariants;

    // Solo varianti realmente disponibili e senza opzioni "fantasma" (N/D)
    const candidates = variants.filter(function(v) {
      return v.available && !(v.options || []).some(isInvalidOption);
    });
    if (!candidates.length) return;

    const cheapest = candidates.reduce(function(min, v) {
      return v.price < min.price ? v : min;
    }, candidates[0]);

    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    cheapest.options.forEach(function(optionValue, index) {
      const fieldset = variantSelects.querySelectorAll('fieldset')[index];
      if (!fieldset) return;

      const input = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
        .find(i => i.value === optionValue);

      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  setTimeout(selectCheapestAvailable, 800);
})();


// Auto-seleziona la memoria più economica disponibile quando cambia il colore
(function() {
  if (window.location.pathname.indexOf('/products/') === -1) return;
  if (!window.__productVariants) return;

  const invalidOptionValues = new Set(['n/d', 'nd', '']);
  function isInvalidOption(val) {
    if (!val) return true;
    return invalidOptionValues.has(val.toString().toLowerCase().trim());
  }

  function selectCheapestAvailableMemory(selectedColor) {
    const variants = window.__productVariants;

    const candidates = variants.filter(function(v) {
      if (!v.available) return false;
      if ((v.options || []).some(isInvalidOption)) return false;
      return v.options.some(function(o) {
        return o.toLowerCase() === selectedColor.toLowerCase();
      });
    });

    if (!candidates.length) return;

    const cheapest = candidates.reduce(function(min, v) {
      return v.price < min.price ? v : min;
    }, candidates[0]);

    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    const fieldsets = variantSelects.querySelectorAll('fieldset');

    cheapest.options.forEach(function(optionValue, index) {
      const fieldset = fieldsets[index];
      if (!fieldset) return;

      const legend = fieldset.querySelector('legend');
      const legendText = legend?.textContent?.toLowerCase() || '';

      if (legendText.includes('memor') || legendText.includes('storage')) {
        const input = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
          .find(i => i.value === optionValue);

        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  document.addEventListener('change', function(e) {
    const input = e.target;
    if (input.type !== 'radio') return;

    const fieldset = input.closest('fieldset');
    const legend = fieldset?.querySelector('legend');
    const legendText = legend?.textContent?.toLowerCase() || '';

    if (legendText.includes('color') || legendText.includes('colore')) {
      setTimeout(function() {
        selectCheapestAvailableMemory(input.value);
      }, 50);
    }
  });
})();

// Rimuove "(N)" dai filtri facet
(function() {
  function pulisciContatori() {
    // Etichette delle checkbox (es. "Bianco (14)")
    document.querySelectorAll('.facet-checkbox__text, .facets__item .visually-hidden').forEach(function(el) {
      if (!el.dataset.cleaned) {
        const originale = el.textContent;
        const pulito = originale.replace(/\s*\(\d+.*?\)\s*$/, '').trim();
        if (originale !== pulito) {
          el.textContent = pulito;
          el.dataset.cleaned = 'true';
        }
      }
    });

    // Titoli delle sezioni filtri (es. "Colore (1)")
    document.querySelectorAll('.facets__summary, .facets__heading, .facets__display-header').forEach(function(el) {
      el.childNodes.forEach(function(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          const originale = node.textContent;
          const pulito = originale.replace(/\s*\(\d+\)\s*/g, '').trimEnd();
          if (originale !== pulito) {
            node.textContent = pulito + ' ';
          }
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', pulisciContatori);

  document.addEventListener('DOMContentLoaded', function() {
    const target = document.getElementById('ProductGridContainer')
      || document.querySelector('.facets')
      || document.body;
    const obs = new MutationObserver(function() {
      pulisciContatori();
    });
    obs.observe(target, { childList: true, subtree: true });
  });
})();


// Mostra prezzo dei prodotti realmente disponibili

// Mostra "Da X" usando solo varianti disponibili - funziona ovunque
(function() {
  const productPriceCache = {};
  const invalidOptionValues = new Set(['n/d', 'nd', '']);

  function isInvalidOption(val) {
    if (!val) return true;
    return invalidOptionValues.has(val.toString().toLowerCase().trim());
  }

  function formatPrice(amount) {
    return '€' + amount.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  async function fixPriceForProduct(handle, priceEl) {
    if (priceEl.dataset.fixed === handle) return;

    try {
      let minPrice = productPriceCache[handle];
      if (minPrice === undefined) {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) {
          productPriceCache[handle] = null;
          return;
        }
        const product = await res.json();
        const availablePrices = product.variants
          .filter(v => v.available)
          // Esclude le varianti "fantasma" con opzioni N/D (non selezionabili in scheda prodotto)
          .filter(v => !(v.options || []).some(isInvalidOption))
          .map(v => v.price / 100) // /products/X.js ritorna i prezzi in centesimi
          .filter(p => !isNaN(p));
        if (availablePrices.length === 0) {
          productPriceCache[handle] = null;
          return;
        }
        minPrice = Math.min(...availablePrices);
        productPriceCache[handle] = minPrice;
      }
      if (minPrice === null) return;

      priceEl.textContent = 'Da ' + formatPrice(minPrice);
      priceEl.dataset.fixed = handle;
    } catch(e) {
      console.error('Fix price error:', e);
    }
  }

  function processAllProductCards() {
    // Cerca tutti i link prodotto in tutta la pagina
    const links = document.querySelectorAll('a[href*="/products/"]');
    const processed = new Set();

    links.forEach(link => {
      const match = link.href.match(/\/products\/([^?#/]+)/);
      if (!match) return;
      const handle = match[1];

      // Trova il wrapper della card in modo mirato: non risale "alla cieca"
      // (in caroselli/slider con card poco isolate, risalire troppi livelli
      // può far prendere il prezzo di UN'ALTRA card vicina)
      const card = link.closest('.card, .card-wrapper, li.grid__item, .grid__item') || link.parentElement;
      if (!card) return;

      const priceEl = card.querySelector('.price-item--regular, .price-item--sale, .price-item');
      if (priceEl && !processed.has(priceEl)) {
        processed.add(priceEl);

        // NON toccare il blocco prezzo principale della pagina prodotto:
        // lì deve comandare solo il tema, in base alla variante selezionata
        if (priceEl.closest('[id*="__main"]')) return;

        fixPriceForProduct(handle, priceEl);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAllProductCards);
  } else {
    processAllProductCards();
  }

  // Osserva aggiornamenti AJAX su tutta la pagina
  document.addEventListener('DOMContentLoaded', function() {
    let debounceTimer;
    const observer = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(processAllProductCards, 300);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();

  // toglie icona basso dx home
document.addEventListener('DOMContentLoaded', function() {

  const hideHcaptcha = () => {
    const el = document.querySelector('#shop-hcaptcha-badge-container');
    if (el) {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('opacity', '0', 'important');
    }
  };

  hideHcaptcha();

  const observer = new MutationObserver(hideHcaptcha);
  observer.observe(document.body, { childList: true, subtree: true });

  [500, 1000, 2000, 4000].forEach(t => setTimeout(hideHcaptcha, t));

});

(function () {
  const OLD_PATH = '/collections/all';
  const NEW_PATH = '/collections/ricondizionati';

  function fixSeeAllLink(root) {
    const links = root.querySelectorAll(`a.default-heading-link[href="${OLD_PATH}"]`);
    links.forEach(link => {
      link.setAttribute('href', NEW_PATH);
    });
  }

  // Fix eventuali istanze già presenti nel DOM al caricamento
  document.addEventListener('DOMContentLoaded', () => fixSeeAllLink(document));

  // Osserva il predictive search per correggere il link ogni volta che viene rigenerato
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        fixSeeAllLink(document);
      }
    }
  });

  // Aspetta che il body sia pronto, poi osserva tutto l'albero
  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();

//escluedi prodotti dalla ricerca

(function () {
  const HIDDEN_HANDLES = [
    'protezione-display'
  ];

  function hideFromPredictiveSearch() {
    const items = document.querySelectorAll('li[id^="predictive-search-option-product"]');
    items.forEach(item => {
      const link = item.querySelector('a[href*="/products/"]');
      if (!link) return;

      const isHidden = HIDDEN_HANDLES.some(handle =>
        link.getAttribute('href').includes(`/products/${handle}`)
      );

      if (isHidden) item.remove();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    hideFromPredictiveSearch();

    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length) {
          hideFromPredictiveSearch();
          break;
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();

//cambia click su protezione display

(function () {
  const NON_CLICKABLE_HANDLES = [
    'protezione-display',
  ];
  const REDIRECT_URL = '/pages/protezione-display';

  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href*="/products/"]');
    if (!link) return;

    const isBlocked = NON_CLICKABLE_HANDLES.some(handle =>
      link.getAttribute('href').includes(`/products/${handle}`)
    );

    if (isBlocked) {
      e.preventDefault();
      e.stopPropagation();
      window.open(REDIRECT_URL, '_blank');
    }
  }, true);
}());

// Nascondi badge batteria su collezioni Rescue e MacBook Ricondizionati — no modifiche a theme.liquid
// Nascondi badge batteria su collezioni Rescue e MacBook Ricondizionati
// - Pagina prodotto: verifica appartenenza via fetch
// - Pagina collezione: check diretto sull'URL
// Nascondi badge batteria su collezioni Rescue e MacBook Ricondizionati
// - Pagina prodotto: verifica appartenenza via fetch
// - Pagina collezione: check diretto sull'URL
(function () {
  var excludedCollections = ['macbook-ricondizionati', 'rescue'];
  var path = window.location.pathname;

  // Caso A: pagina di listing di una collezione esclusa -> nascondi tutti i badge
  var collectionMatch = path.match(/\/collections\/([^/?#]+)/);
  if (collectionMatch && excludedCollections.indexOf(collectionMatch[1]) !== -1) {
    document.body.classList.add('no-badge-batteria');
    return;
  }

  // Caso B: pagina prodotto -> nascondi solo se il prodotto è in una collezione esclusa
  var productMatch = path.match(/\/products\/([^/?#]+)/);
  if (productMatch) {
    var currentHandle = productMatch[1];
    Promise.all(excludedCollections.map(function (handle) {
      return fetch('/collections/' + handle + '/products.json?limit=250')
        .then(function (res) { return res.ok ? res.json() : { products: [] }; })
        .then(function (data) { return data.products.some(function (p) { return p.handle === currentHandle; }); })
        .catch(function () { return false; });
    })).then(function (results) {
      if (results.some(Boolean)) document.body.classList.add('no-badge-batteria');
    });
    return;
  }

  // Caso C: qualunque altra pagina (home, altre collezioni, ecc.)
  // -> scandisci le card visibili e nascondi solo il badge dei prodotti Rescue/MacBook
  var excludedHandlesPromise = Promise.all(excludedCollections.map(function (handle) {
    return fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (res) { return res.ok ? res.json() : { products: [] }; })
      .then(function (data) { return data.products.map(function (p) { return p.handle; }); })
      .catch(function () { return []; });
  })).then(function (arrays) {
    return new Set([].concat.apply([], arrays));
  });

  function hideBadgesInCards(excludedHandles) {
    document.querySelectorAll('.samita_productLabel').forEach(function (label) {
      if (label.dataset.batteryChecked) return;
      var link = label.closest('a[href*="/products/"]');
      if (!link) {
        var card = label.closest('[class*="card"]');
        link = card ? card.querySelector('a[href*="/products/"]') : null;
      }
      if (!link) return;
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      label.dataset.batteryChecked = '1';
      if (excludedHandles.has(m[1])) {
        var container = label.closest('.samita-container') || label;
        container.style.setProperty('display', 'none', 'important');
      }
    });
  }

  excludedHandlesPromise.then(function (excludedHandles) {
    hideBadgesInCards(excludedHandles);
    new MutationObserver(function () { hideBadgesInCards(excludedHandles); })
      .observe(document.body, { childList: true, subtree: true });
  });
})();

  // Togli il DA prima del prezzo

(function () {
  function stripDaPrefix() {
    document.querySelectorAll('.price-item.price-item--regular[data-fixed]').forEach(function (el) {
      // Solo il blocco prezzo della pagina prodotto (id "price-template--...__main")
      if (!el.closest('[id*="__main"]')) return;

      var newText = el.textContent.replace(/^\s*Da\s+/i, '');
      if (newText !== el.textContent) {
        el.textContent = newText;
      }
    });
  }

  stripDaPrefix();
  document.addEventListener('DOMContentLoaded', stripDaPrefix);

  var debounceTimer;
  var bodyObserver = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(stripDaPrefix, 50);
  });

  bodyObserver.observe(document.body, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();

// Mostra subito il video nella scheda prodotto, se presente, indipendentemente dalla posizione tra gli swatch
(function () {
  function attivaVideo(gallery) {
    var thumbList = gallery.querySelector('.thumbnail-list');
    if (!thumbList) return;

    var videoBtn = thumbList.querySelector('button[aria-label*="video" i]');
    if (!videoBtn) return;

    var li = videoBtn.closest('[data-target]');
    var mediaId = li ? li.getAttribute('data-target') : null;
    if (!mediaId) return;

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaId, false);
    } else {
      videoBtn.click();
    }
  }

  function run() {
    document.querySelectorAll('media-gallery').forEach(attivaVideo);
  }

  if (window.customElements && customElements.get('media-gallery')) {
    run();
  } else if (window.customElements) {
    customElements.whenDefined('media-gallery').then(function () {
      setTimeout(run, 50);
    });
  }

  // fallback di sicurezza, nel caso il component tardi ad agganciarsi
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(run, 400);
  });
})();

// Menu Extra Riparalo
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('details, .mega-menu').forEach(function (menu) {
    var summary = menu.querySelector('summary');
    if (summary && summary.textContent.trim() === 'Riparalo') {
      var items = menu.querySelectorAll('.grid__item');
      if (items.length >= 4 && !menu.querySelector('.riparalo-extra-links')) {
        var grid = items[0].closest('.grid');
        if (grid) {
          var extra = document.createElement('div');
          extra.className = 'riparalo-extra-links';
          extra.innerHTML = `
            <a href="https://www.riparalo.store/pages/chi-siamo">Chi Siamo</a>
            <a href="https://www.riparalo.store/pages/telefoni-ricondizionati">Ricondizionati</a>
            <a href="https://www.riparalo.store/pages/servizi">Servizi</a>
            <a href="https://www.riparalo.store/pages/consulenza">Consulenza</a>
            <a href="https://www.riparalo.store/pages/franchising">Franchising</a>
          `;
          grid.appendChild(extra);
        }
      }
    }
  });
});

// Varianti non disponibili
(function () {
  if (window.__ndVariantiInit) return;
  window.__ndVariantiInit = true;

  function nascondiVariantiNonDisponibili(container) {
    var root = container || document;

    root.querySelectorAll('input.disabled').forEach(function (input) {
      input.style.display = 'none';
      var label = root.querySelector('label[for="' + input.id + '"]');
      if (label) label.style.display = 'none';
    });

    root.querySelectorAll('input[type="radio"]:not(.disabled)').forEach(function (input) {
      input.style.display = '';
      var label = root.querySelector('label[for="' + input.id + '"]');
      if (label) label.style.display = '';
    });

    // Se l'opzione attualmente selezionata è stata nascosta (disabled),
    // sposta la selezione sulla prima variante disponibile dello stesso fieldset
    root.querySelectorAll('fieldset').forEach(function (fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked && checked.classList.contains('disabled')) {
        var firstAvailable = fieldset.querySelector('input[type="radio"]:not(.disabled)');
        if (firstAvailable) {
          firstAvailable.checked = true;
          firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    nascondiVariantiNonDisponibili();
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.querySelector && node.querySelector('input[type="radio"]')) {
            nascondiVariantiNonDisponibili(node);
          }
        });
      });
      nascondiVariantiNonDisponibili();
    });
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });
  });
})();

// Unifica varianti duplicate del filtro Memoria (es. 128GB / 128gb)
(function () {
  function normalizzaMemoria(str) {
    if (!str) return '';
    return str.trim().toLowerCase();
  }

  function formattaMemoria(str) {
    // Forza il formato "128GB" a partire da qualsiasi casistica (128gb, 128Gb, ecc.)
    var match = str.trim().match(/^(\d+)\s*gb$/i);
    if (match) return match[1] + 'GB';
    return str.trim();
  }

  function unificaFiltroMemoria(root) {
    root = root || document;
    var inputs = root.querySelectorAll(
      'input[type="checkbox"][name*="option.memoria" i], input[type="checkbox"][name*="option.storage" i]'
    );
    if (!inputs.length) return;

    var gruppi = {};
    inputs.forEach(function (input) {
      var key = normalizzaMemoria(input.value);
      if (!key) return;
      if (!gruppi[key]) gruppi[key] = [];
      gruppi[key].push(input);
    });

    Object.keys(gruppi).forEach(function (key) {
      var group = gruppi[key];
      if (group.length < 2) return;

      var primario = group[0];
      var duplicati = group.slice(1);

      if (!primario.dataset.memUnified) {
        primario.dataset.memUnified = '1';

        // Uniforma il testo visibile al formato standard (es. 128GB)
        var liPrimario = primario.closest('li');
        if (liPrimario) {
          var testoEl = liPrimario.querySelector('.facet-checkbox__text, .visually-hidden');
          if (testoEl) {
            var testoOriginale = testoEl.textContent;
            var pulito = testoOriginale.replace(/\s*\(\d+.*?\)\s*$/, '');
            var extra = testoOriginale.slice(pulito.length);
            testoEl.textContent = formattaMemoria(pulito) + extra;
          }
        }

        // Se un duplicato era già selezionato (es. da URL), seleziona anche il primario
        if (group.some(function (i) { return i.checked; }) && !primario.checked) {
          primario.checked = true;
        }

        // Alla selezione/deselezione del primario, replica lo stato sui duplicati nascosti
        primario.addEventListener('change', function () {
          duplicati.forEach(function (dup) {
            if (dup.checked !== primario.checked) {
              dup.checked = primario.checked;
              dup.dispatchEvent(new Event('input', { bubbles: true }));
              dup.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      }

      // Nasconde le voci duplicate (restano nel DOM per essere spuntate via JS)
      duplicati.forEach(function (dup) {
        if (dup.checked && !primario.checked) {
          primario.checked = true;
        }
        var liDup = dup.closest('li');
        if (liDup) {
          liDup.style.display = 'none';
        } else {
          dup.style.display = 'none';
          var label = root.querySelector('label[for="' + dup.id + '"]');
          if (label) label.style.display = 'none';
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    unificaFiltroMemoria();
    var target = document.querySelector('.facets') || document.body;
    var obs = new MutationObserver(function () {
      unificaFiltroMemoria();
    });
    obs.observe(target, { childList: true, subtree: true });
  });
})();